import logoUrl from "../assets/muviarts-logo.png";

// MuviArts.Online brand mark — the green WhatsApp-automation "M" logo.
export function BrandMark({ size = 32, className = "" }) {
  return (
    <img
      src={logoUrl}
      alt="MuviArts.Online"
      width={size}
      height={size}
      className={`object-contain ${className}`}
      style={{ width: size, height: size }}
      data-testid="brand-mark"
    />
  );
}

export function BrandLogo({ markSize = 32, textClass = "text-white", showText = true }) {
  return (
    <div className="flex items-center gap-2.5">
      <BrandMark size={markSize} />
      {showText && (
        <span className={`font-heading text-base font-extrabold tracking-tight ${textClass}`}>
          MuviArts<span className="opacity-70 font-semibold">.Online</span>
        </span>
      )}
    </div>
  );
}
